import { UPDATE_USER_PUSH_TOKEN } from '../constants';

export function updatePushToken (userId, token) {
	return {
		type: UPDATE_USER_PUSH_TOKEN,
		payload: token,
		userId: userId
	}
}
